import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=8fba6424&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=8fba6424&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/StratusCAD/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fba6424')) {
      api.createRecord('8fba6424', component.options)
    } else {
      api.reload('8fba6424', component.options)
    }
    module.hot.accept("./BreadCrumbs.vue?vue&type=template&id=8fba6424&", function () {
      api.rerender('8fba6424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/navigation/BreadCrumbs.vue"
export default component.exports